import { Registrering, UserState } from 'models';

export const notReservedOrReservedByMe = (userState: UserState, registrering: Registrering) => {
  if (!registrering.reservation.reserverad_av_anvandarid) return true;

  return registrering.reservation.reserverad_av_anvandarid === userState.data?.username;
};
